export const ANTHROPIC_FABLE_5_MODEL_ID = "claude-fable-5";
export const ANTHROPIC_FABLE_5_MODEL_REF = "anthropic/claude-fable-5";
export type AnthropicFable5ModelRef = typeof ANTHROPIC_FABLE_5_MODEL_REF;

export const ANTHROPIC_FABLE_5_1_MODEL_ID = "claude-fable-5-1";
export const ANTHROPIC_FABLE_5_1_MODEL_REF = "anthropic/claude-fable-5-1";
export type AnthropicFable51ModelRef = typeof ANTHROPIC_FABLE_5_1_MODEL_REF;

export type AnthropicFableModelId =
  | typeof ANTHROPIC_FABLE_5_MODEL_ID
  | typeof ANTHROPIC_FABLE_5_1_MODEL_ID;

export function isAnthropicFable5ModelRef(
  modelRef: string | null | undefined,
): modelRef is AnthropicFable5ModelRef {
  return modelRef === ANTHROPIC_FABLE_5_MODEL_REF;
}

export function isAnthropicFable51ModelRef(
  modelRef: string | null | undefined,
): modelRef is AnthropicFable51ModelRef {
  return modelRef === ANTHROPIC_FABLE_5_1_MODEL_REF;
}

/**
 * Anthropic-direct model **id** (not ref) for either Fable generation.
 * Ids never key the ref-keyed capability tables — keep the distinction.
 */
export function isAnthropicFableModelId(
  modelId: string | null | undefined,
): modelId is AnthropicFableModelId {
  return (
    modelId === ANTHROPIC_FABLE_5_MODEL_ID ||
    modelId === ANTHROPIC_FABLE_5_1_MODEL_ID
  );
}

/** Anthropic-direct model **id** for Fable 5.1 only. */
export function isAnthropicFable51ModelId(
  modelId: string | null | undefined,
): modelId is typeof ANTHROPIC_FABLE_5_1_MODEL_ID {
  return modelId === ANTHROPIC_FABLE_5_1_MODEL_ID;
}
